export const ckReturnLink = 'https://www.creditkarma.com/u/student-loans';
export const fidelityReturnLink = 'https://www.fidelity.com/forgiveness';
export const fidelityOverPaymentsReturnLink =
  'https://myguidance.fidelity.com/ftgw/pna/public/pgc/debt-planning/';
export const aftLoginLink = 'https://www.aft.org/members-only';
export const aftJoinLink = 'https://www.aft.org/join-aft';
